import { hotFinalize } from '../components/Handsontable/Handsontable'

export default [
    hotFinalize
]


// WEBPACK FOOTER //
// ./App/config/finalizers.js